import React from "react";
import {
  Box,
  Card,
  Container,
  Stack,
  TextField,
  Typography,
  Checkbox,
} from "@mui/material";
// import Footer from "../../Component/Footer";
import { useState } from "react";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { MdOutlineVisibilityOff, MdOutlineVisibility } from "react-icons/md";

const ExamLoginCas = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };
  return (
    <div className="main-bebe-container">
      <Box component="div" className="bece-update">
        <Container>
          <Card className="login-card" elevation={5}>
            <Container component="div">
              <Stack style={{ textAlign: "center", paddingTop: "2rem" }}>
                <Typography variant="h5" style={{ fontWeight: "bold" }}>
                  EXAM LOGIN
                </Typography>
                <Typography variant="subtitle2" style={{ paddingTop: "10px" }}>
                  {" "}
                  CAS PLACEMENT TEST{" "}
                </Typography>
              </Stack>
              <Container style={{ marginTop: "3rem" }}>
                <div style={{ marginLeft: "1.5rem" }}>
                  <Stack>
                    <Typography
                      variant="p"
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Username
                    </Typography>
                    <TextField
                      type="username"
                      label="Enter username"
                      size="small"
                      color="secondary"
                      style={{ width: "90%" }}
                    />
                  </Stack>

                  <Stack>
                    <Typography
                      variant="p"
                      style={{
                        fontWeight: "bold",
                        marginBottom: "10px",
                        marginTop: "1rem",
                      }}
                    >
                      Password111
                    </Typography>
                    <div style={{ display: "flex" }}>
                      <TextField
                        type={showPassword ? "text" : "password"}
                        label="Password"
                        size="small"
                        color="secondary"
                        style={{
                          width: "90%",
                          margingTop: "1rem",
                          position: "relative",
                        }}
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                      />
                      <div
                        style={{
                          position: "absolute",
                          cursor: "pointer",
                          right: "19%",
                          paddingTop: "8px",
                        }}
                      >
                        {showPassword ? (
                          <MdOutlineVisibility
                            onClick={togglePasswordVisibility}
                            size={25}
                          />
                        ) : (
                          <MdOutlineVisibilityOff
                            onClick={togglePasswordVisibility}
                            size={25}
                          />
                        )}
                      </div>
                    </div>
                  </Stack>
                  <div style={{ marginTop: "10px" }}>
                    <Checkbox
                      id="check"
                      checked={rememberMe}
                      onChange={handleRememberMeChange}
                      color="secondary"
                    />
                    <Typography variant="p">Remember Me</Typography>
                  </div>
                  <Stack>
                    {" "}
                    <Button
                      href="/requisition/junior"
                      variant="contained"
                      color="secondary"
                      size="large"
                      style={{
                        marginTop: "2rem",
                        width: "90%",
                      }}
                    >
                      {" "}
                      Login{" "}
                    </Button>{" "}
                  </Stack>
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    marginTop="30px"
                    textAlign="center"
                  >
                    Don't have an account?{" "}
                    <Link
                      href="/register"
                      style={{
                        textDecoration: "none",
                        textTransform: "inherit",
                      }}
                      component={Button}
                      color="secondary"
                    >
                      Register
                    </Link>{" "}
                    |
                    <Link
                      href="/"
                      style={{
                        textDecoration: "none",
                        textTransform: "inherit",
                      }}
                      component={Button}
                      color="secondary"
                    >
                      Back to home page.
                    </Link>
                  </Typography>
                </div>
              </Container>
            </Container>
          </Card>
        </Container>
      </Box>

      {/* <Footer /> */}
    </div>
  );
};

export default ExamLoginCas;
